<template>
  <div id="contact" class="login f-c-s">
    <div class="loginpage f-c-s f-d-c w-66 h-100">
      <div class="f-c-c w-100 h-15">
        <Navbar />
      </div>
      <div class="maincontent f-s-s w-100 h-70">
        <div class="helpContent m-t-15 f-c-c f-d-c">
          <div class="address f-c-c f-w-w t-a-c w-80 mb-4">
            <span style="margin-left: 0; text-align: center"
              >در صورت بروز مشکل و یا سوال می توانید با شماره 42863863-021 تماس
              حاصل نمایید.</span
            >
          </div>
        </div>
        <b-img
          class="contentsvg pl-3 m-t-10"
          :src="require(`@/assets/images/home/content.svg`)"
          style="min-width: 300px; width: 25%"
        ></b-img>
      </div>

      <div class="gapMaterial f-c-b w-100 h-15">
        <div class="text f-c-c">
          کلیه حقوق مادی و معنوی متعلق به دانشگاه آزاد اسلامی واحد الکترونیکی می
          باشد.
        </div>
        <a
          data-v-efcdee58=""
          style="width: 80px; height: 80px"
          referrerpolicy="origin"
          target="_blank"
          href="https://trustseal.enamad.ir/?id=326758&amp;Code=bjOij5apDKj7OdTL5Wi7"
          ><img
            data-v-efcdee58=""
            referrerpolicy="origin"
            src="https://vadaroom.ec.iau.ir/img/logo_enamad.png"
            alt=""
            id="bjOij5apDKj7OdTL5Wi7"
            style="cursor: pointer; width: 100%; height: 100%"
        /></a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Navbar from "@/components/LoginNavbar";
export default {
  name: "Contact",
  data() {
    return {};
  },
  created() {
    this.isShowNavFunction(4);
  },
  computed: {},
  components: {
    Navbar,
  },
  methods: {
    ...mapActions("gap", ["isShowNavFunction"]),
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
</style>